export const CHATBOT_EVENTS = {
  OPEN: "Advisor Open ChatBot",
  CLOSE: "Advisor Close ChatBot",
  EXPAND: "Advisor Expand ChatBot",
  COLLAPSE: "Advisor Collapse ChatBot",
  NEW_SESSION: "Advisor New ChatBot Session",
  SEND_MESSAGE: "Advisor Send ChatMessage",
  FIRST_MESSAGE: "Advisor First ChatMessage",
  COPY_MESSAGE: "Advisor Copy ChatMessage",
  UNUSED_SESSION: "Advisor Chatbot Unused Session",
  ERROR: "Advisor ChatBot Error",
} as const;

export const STANDARD_DRAWER_WIDTH = 600;
export const LARGE_DRAWER_WIDTH = 800;
export const DEFAULT_RIGHT_POSITION = 18;
export const EXTRA_LARGE_DRAWER_WIDTH = 1004;
export const EXTRA_LARGE_DRAWER_MARGIN = 36;
export const DRAWER_MARGIN = 12;
